<div
    class="w-6 h-6 cursor-pointer"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (click)="toggleUrgent()"
>
    <img
        [src]="'assets/icons/bookmark/' + icon() + '.svg'"
        [class.opacity-90]="!hovered() && !internalUrgent()"
        [style.filter]="
            internalUrgent()
                ? 'brightness(0) saturate(100%) invert(27%) sepia(90%) saturate(700%) hue-rotate(330deg)'
                : 'brightness(0) invert(1)'
        "
        class="w-6 h-6"
        alt=""
    />
</div>
